/* byo-lp.js -- the Build Your Own landing page's three behaviours (D151;
   Claude Design's README section 7). Everything they touch is already in the
   HTML; without this file the chips are links to the type pages, every card
   shows, and the sticky bar stays out of sight with its space kept.

   - Filter chips (#grid): show the cards of one type, mark the chip current.
   - Show more (phones): four cards of the current filter, then "Show more (N)".
   - Sticky bar (phones): appears once the hero's Start Building has scrolled
     up out of view, and goes when it comes back. */
(() => {
  const phone = window.matchMedia('(max-width: 767px)');

  const grid = document.querySelector('[data-lp-grid]');
  if (grid) {
    const chips = [...grid.querySelectorAll('[data-lp-chip]')];
    const cards = [...grid.querySelectorAll('[data-lp-card]')];
    const list = grid.querySelector('[data-lp-cards]');
    let filter = '';
    let open = false;
    let more = null;

    const apply = () => {
      const match = cards.filter((c) => !filter || c.dataset.type === filter);
      cards.forEach((c) => { c.hidden = !match.includes(c); });
      const limit = phone.matches && !open ? 4 : Infinity;
      match.forEach((c, i) => { if (i >= limit) c.hidden = true; });
      const rest = match.length - Math.min(limit, match.length);
      if (rest > 0) {
        if (!more) {
          more = document.createElement('button');
          more.type = 'button';
          more.className = 'byo-lp-more';
          more.addEventListener('click', () => {
            open = true;
            const first = cards.find((c) => c.hidden && (!filter || c.dataset.type === filter));
            apply();
            if (first) { const a = first.querySelector('h3 a'); if (a) a.focus({ preventScroll: true }); }
          });
          list.after(more);
        }
        more.innerHTML = `Show more <span>(${rest})</span>`;
      } else if (more) {
        more.remove();
        more = null;
      }
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        filter = chip.dataset.type || '';
        open = false;
        chips.forEach((c) => (c === chip ? c.setAttribute('aria-current', 'true') : c.removeAttribute('aria-current')));
        apply();
      });
    });
    phone.addEventListener('change', apply);
    apply();
  }

  const btn = document.querySelector('[data-lp-hero-btn]');
  const bar = document.querySelector('[data-lp-sticky]');
  if (btn && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.toggleAttribute('inert', !on);
    }).observe(btn);
  }
})();
